import {createSlice} from "@reduxjs/toolkit";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const AttendanceAdjustmentPersistSlice = createSlice({
    name: 'attendanceAdjustmentPersistSection',
    initialState: {
        adjustedChangeRequest: null,
        // Id of the change request the persisted rows belong to. Without it the
        // rows of a previously visited request would leak into the next one and
        // their item ids would be rejected by the backend.
        adjustedChangeRequestId: null
    },
    reducers: {
        SaveRowsAdjusted: (state, action) => {
            const { rows, requestId } = action.payload || {};
            state.adjustedChangeRequest = rows;
            state.adjustedChangeRequestId = requestId ?? null;
        },
        ClearRowsAdjusted: (state) => {
            state.adjustedChangeRequest = null;
            state.adjustedChangeRequestId = null;
        }
    },
    extraReducers: {},
});

export const { SaveRowsAdjusted, ClearRowsAdjusted } = AttendanceAdjustmentPersistSlice.actions;

export default AttendanceAdjustmentPersistSlice.reducer;
